import React from 'react';
import './Total.scss';

const Total = ({children}) => {
  return <span className='total'>{children}</span>;
};

export default Total;
